/**
* Rhythm Callout JS
* -----------------------------------------------------------------------------
*
* All the JS for the Rhythm Callout component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'rhythm-callout',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.rhythm-callout' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--rhythm-callout' )[0], {
          pagination: false,
          arrows: false,
          gap: '32px',
          perPage: 1,
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'rhythm-callout', COMPONENT );
} )( app );
